import React from 'react';
import { MessageSquareIcon, GiftIcon, LeafIcon, PackageIcon } from 'lucide-react';
export function AddOns() {
  return <section className="py-16 bg-white" data-id="element-33">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-34">
        <div className="text-center mb-16" data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-36">
            Enhance Your Experience
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-37">
            Customize your subscription with these premium add-ons
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-38">
          {/* Cards & Messages */}
          <div className="bg-white border border-gray-200 rounded-xl p-6 hover:border-pink-200 hover:shadow-md transition-all" data-id="element-39">
            <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-40">
              <MessageSquareIcon className="h-6 w-6 text-pink-700" data-id="element-41" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-42">
              Cards & Messages
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-43">
              Add printed or handwritten notes to make your gift even more
              special.
            </p>
            <p className="text-pink-700 font-medium" data-id="element-44">From KES 200</p>
          </div>
          {/* Gifting Bundles */}
          <div className="bg-white border border-gray-200 rounded-xl p-6 hover:border-pink-200 hover:shadow-md transition-all" data-id="element-45">
            <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-46">
              <GiftIcon className="h-6 w-6 text-pink-700" data-id="element-47" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-48">
              Gifting Bundles
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-49">
              Pair your flowers with wine, chocolates, or candles for a complete
              gift.
            </p>
            <p className="text-pink-700 font-medium" data-id="element-50">From KES 1,500</p>
          </div>
          {/* Plant Care */}
          <div className="bg-white border border-gray-200 rounded-xl p-6 hover:border-pink-200 hover:shadow-md transition-all" data-id="element-51">
            <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-52">
              <LeafIcon className="h-6 w-6 text-pink-700" data-id="element-53" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-54">Plant Care</h3>
            <p className="text-gray-600 mb-4" data-id="element-55">
              Get maintenance visits and guaranteed replacements for your
              plants.
            </p>
            <p className="text-pink-700 font-medium" data-id="element-56">From KES 800/month</p>
          </div>
          {/* Vases & Decor */}
          <div className="bg-white border border-gray-200 rounded-xl p-6 hover:border-pink-200 hover:shadow-md transition-all" data-id="element-57">
            <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-58">
              <PackageIcon className="h-6 w-6 text-pink-700" data-id="element-59" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-60">
              Vases & Decor
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-61">
              Premium vases and decorative items for your home or office setup.
            </p>
            <p className="text-pink-700 font-medium" data-id="element-62">From KES 1,200</p>
          </div>
        </div>
      </div>
    </section>;
}